import { Activity, Ban, BadgeCheck, Building, Building2, FileChartColumn, LayoutDashboard, ListChecks, MonitorCheck, MonitorDown, MonitorSmartphone, ShieldCheck, Sunrise, Tags, Users, UsersRound } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import type { Role } from "@/api/types";
import { ADMIN, reaches, STAFF, TENANT } from "@/auth/roles";
import type { Access, Reach } from "@/auth/roles";

export type NavItem = { to: string; label: string; icon: LucideIcon; roles: readonly Role[]; reach?: Reach; group?: NavGroup };
export type NavGroup = "People" | "Devices" | "Settings";

/** The one list of destinations. The router uses the same roles to guard each page. */
export const NAV: NavItem[] = [
  { to: "/organisations", label: "Organisations", icon: Building2, roles: ["super_admin"] },
  { to: "/plans", label: "Plans", icon: Tags, roles: ["super_admin"] },
  { to: "/suspended", label: "Suspended", icon: Ban, roles: ["super_admin"] },
  { to: "/my-day", label: "My day", icon: Sunrise, roles: TENANT },
  { to: "/overview", label: "Overview", icon: LayoutDashboard, roles: STAFF, reach: "others", group: "People" },
  { to: "/live", label: "Live", icon: Activity, roles: STAFF, reach: "others", group: "People" },
  { to: "/reports", label: "Reports", icon: FileChartColumn, roles: STAFF, reach: "others", group: "People" },
  { to: "/people", label: "People", icon: Users, roles: STAFF, reach: "others", group: "People" },
  { to: "/teams", label: "Teams", icon: UsersRound, roles: STAFF, reach: "others", group: "People" },
  { to: "/roles", label: "Job roles", icon: BadgeCheck, roles: ADMIN, group: "People" },
  { to: "/connect", label: "Connect a computer", icon: MonitorCheck, roles: TENANT, group: "Devices" },
  { to: "/devices", label: "Devices", icon: MonitorSmartphone, roles: ADMIN, reach: "devices", group: "Devices" },
  { to: "/agent", label: "Agent", icon: MonitorDown, roles: ADMIN, group: "Devices" },
  { to: "/statuses", label: "Statuses", icon: ListChecks, roles: ADMIN, group: "Settings" },
  { to: "/policies", label: "Policies", icon: ShieldCheck, roles: ADMIN, group: "Settings" },
  { to: "/organisation", label: "Organisation", icon: Building, roles: ADMIN, group: "Settings" },
];

/** The destinations a person has: the pages their access lists, and any their job role reaches (Who sees whom). */
export function navFor(role: Role, access: Access | undefined): NavItem[] {
  return NAV.filter((item) => item.roles.includes(role) || reaches(item.reach, access, role));
}
